export * from './bulk-confirm.component';
